import { render, staticRenderFns } from "./ConversationForm.vue?vue&type=template&id=397e44b5&scoped=true&"
import script from "./ConversationForm.vue?vue&type=script&lang=js&"
export * from "./ConversationForm.vue?vue&type=script&lang=js&"
import style0 from "./ConversationForm.vue?vue&type=style&index=0&id=397e44b5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "397e44b5",
  null
  
)

export default component.exports